<template>
  <div>
    <keep-alive :include="keepAliveList">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
export default {
  name: 'LayoutDefault',

  components: {},
  computed: {
    ...mapGetters({
      keepAliveList: 'get_keepAliveList'
    })
  },
  data () {
    return {}
  },
  created () {
  },
  mounted () {
    this.$toast.setDefaultOptions('loading', { forbidClick: true })
    this.$dialog.setDefaultOptions({
      confirmButtonColor: '#DA3939',
      className: 'confirmDIA'
    })
  },
  methods: {
  }
}
</script>

<style>
  @import "./assets/style/index.css";
  body {
    margin: 0 auto;
  }

</style>
